export default {
  contact_provider: 'Please contact your provider to switch this on.',
};
